import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatWelcomeDefaultVariants = {}
const chatWelcomeCompoundVariants = []

const chatWelcomeSlotNames = [
  [
    "root",
    "chatWelcome__root"
  ],
  [
    "message",
    "chatWelcome__message"
  ],
  [
    "suggestions",
    "chatWelcome__suggestions"
  ]
]
const chatWelcomeSlotFns = /* @__PURE__ */ chatWelcomeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatWelcomeDefaultVariants, getSlotCompoundVariant(chatWelcomeCompoundVariants, slotName))])

const chatWelcomeFn = memo((props = {}) => {
  return Object.fromEntries(chatWelcomeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatWelcomeVariantKeys = []
const getVariantProps = (variants) => ({ ...chatWelcomeDefaultVariants, ...compact(variants) })

export const chatWelcome = /* @__PURE__ */ Object.assign(chatWelcomeFn, {
  __recipe__: false,
  __name__: 'chatWelcome',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatWelcomeVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatWelcomeVariantKeys)
  },
  getVariantProps
})